import React from 'react';

const Dashboard: React.FC = () => {
  return (
    <div>
      <h2>Dashboard Page</h2>
      <p>Welcome to your dashboard!</p>
    </div>
  );
};

export default Dashboard;